import React from "react";

import { Plus } from "icons";

import { Button } from "clearsense-ui/components";

import { JOB_STATUS_TYPE } from "../../../constants";

const PredictJobCreate = ({
  jobDetails,
  predictionJob,
  createPredictionJob,
  isLoading,
}) => (
  <div
    className="flex items-center space-x-4"
    data-cy="analysis-subheader-right-action-block-div"
  >
    <Button
      label="New Predictions"
      icon={Plus}
      onClick={() => createPredictionJob()}
      loading={isLoading}
      disabled={
        !jobDetails || predictionJob?.status === JOB_STATUS_TYPE.running
      }
      data-cy="new-prediction-button"
    />
  </div>
);

export default PredictJobCreate;
